import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as i18next from 'i18next';
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';
import { validationEmail } from 'core/validators';
import router from 'src/router';
import * as api from 'core/api';
import { G2S } from 'core/g2s';
import * as auth from 'core/auth';
import moment from 'moment';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

enum ViewType {
    loading = 'loading',
    evaluation = 'evaluation',
    notSolver = 'not_solved',
    reviewSent = 'sent',
} 

enum ScoreType {
    notSolved = 'not_solved',
    bad = 'bad',
    normal = 'normal',
    excellent = 'excellent',
}

@WithRender
@Component
export default class SupportFeedbackComponent extends Vue {
    score: ScoreType | '' = '';
    ticketId: number | null = null;
    description: string = '';

    sentTitle: string = '';
    sentMessage: string = '';

    view: ViewType = ViewType.loading;

    excellentEvaluation: any[] = [
        {
            label: 'Скорость решения',
            value: 'Скорость решения',
            isSelected: false,
        },
        {
            label: 'Подробность ответов',
            value: 'Подробность ответов',
            isSelected: false,
        },
        {
            label: 'Понятность объяснений',
            value: 'Понятность объяснений',
            isSelected: false,
        },
        {
            label: 'Отзывчивость и желание помочь',
            value: 'желание помочь',
            isSelected: false,
        },
        {
            label: 'Полезные и актуальные советы',
            value: 'актуальные советы',
            isSelected: false,
        },
    ];
    normalEvaluation: any[] =[
        {
            label: 'Ничего, всё и так нормально решили',
            value: 'Ничего, всё и так нормально решили',
            isSelected: false,
        },
        {
            label: 'Хочу меньше делать самостоятельно',
            value: 'Хочу меньше делать самостоятельно',
            isSelected: false,
        },
        {
            label: 'Хочу, чтобы мне быстрее отвечали',
            value: 'Хочу, чтобы мне быстрее отвечали',
            isSelected: false,
        },
        {
            label: 'Мне не подходит тон общения',
            value: 'Мне не подходит тон общения',
            isSelected: false,
        },
        {
            label: 'Не всё понятно объяснили',
            value: 'Не всё понятно объяснили',
            isSelected: false,
        },
    ];
    badEvaluation: any[] = [
        {
            label: 'Долго отвечали',
            value: 'Долго отвечали',
            isSelected: false,
        },
        {
            label: 'Неподходящий тон общения',
            value: 'Неподходящий тон общения',
            isSelected: false,
        },
        {
            label: 'Много делать самостоятельно',
            value: 'Много делать самостоятельно',
            isSelected: false,
        },
        {
            label: 'Непонятно объяснили',
            value: 'Непонятно объяснили',
            isSelected: false,
        },
        {
            label: 'Не сразу поняли мой вопрос',
            value: 'Не сразу поняли мой вопрос',
            isSelected: false,
        },
        {
            label: 'Не устроили условия',
            value: 'Не устроили условия',
            isSelected: false,
        },
        {
            label: 'Не понравились рекомендации',
            value: 'Не понравились рекомендации',
            isSelected: false,
        },
    ];

    async mounted() {
        this.loadModel();
        await this.send();
    }


    async send() {
        if (
            this.score &&
            this.ticketId &&
            Object.values(ScoreType).includes(this.score)
        ) {
            let selectedValues: any[] = [];

            switch (this.score) {
                case ScoreType.excellent:
                    selectedValues = this.excellentEvaluation
                        .filter(item => item.isSelected)
                        .map(item => item.value);
                    break;
                case ScoreType.normal:
                    selectedValues = this.normalEvaluation
                        .filter(item => item.isSelected)
                        .map(item => item.value);
                    break;
                case ScoreType.bad:
                    selectedValues = this.badEvaluation
                        .filter(item => item.isSelected)
                        .map(item => item.value);
                    break;
                default:
                    break;
            }

            const request = {
                comments: selectedValues,
            };
            if (this.description.length) {
                request.comments.push(this.description);
            }

            await fetch('https://faq-api.aviasales.ru/zendesk/csi/rate', {
                method: 'POST',
                body: JSON.stringify({
                    comments: request.comments,
                    rating: this.score,
                    ticket_id: this.ticketId,
                }),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            });
        }
    }

    loadModel() {
        if (this.$route.query.zd_support_ticket_score) {
            this.score = <ScoreType>this.$route.query.zd_support_ticket_score;
        }
        if (this.$route.query.zd_support_ticket_id) {
            this.ticketId = Number(this.$route.query.zd_support_ticket_id);
        }

        this.view = this.score === ScoreType.notSolved ? ViewType.notSolver : ViewType.evaluation;
    }

    onSubmit() {
        this.finishSubmit();
        this.send();
    }

    finishSubmit() {
        window.scrollTo(0, 0);
        if (this.view === ViewType.evaluation) {
            this.sentTitle = 'Спасибо, что помогли нам стать лучше';
            this.sentMessage = 'Мы рядом 24/7 и всегда готовы помочь';
        } else {
            this.sentTitle = 'Спасибо, что подсветили проблему';
            this.sentMessage = 'Скоро вернёмся с ответом';
        }
        this.view = ViewType.reviewSent;
        this.view = ViewType.reviewSent;
    }

}
